module.exports = __webpack_public_path__ + "img/15.b130c93e.jpg";